import { render } from "./ModuleTabbedContent.vue?vue&type=template&id=ffdeddaa"
import script from "./ModuleTabbedContent.vue?vue&type=script&lang=js"
export * from "./ModuleTabbedContent.vue?vue&type=script&lang=js"

import "./ModuleTabbedContent.vue?vue&type=style&index=0&id=ffdeddaa&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__